import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../../../../core/constants/api-routes';
import { SaveOrderBillingInformationRequest } from '../../../order-details/components/order-billing-information-form-modal/models/save-order-billing-information-request';
import { OrderBillingInformationResponse } from '../../../order-details/models/order-billing-information-response';

@Injectable({
    providedIn: 'root',
})
export class OrderBillingInformationService {
    private readonly orderBillingInformationApiRoute =
        ApiRouteConstants.OrderBillingInformation;

    constructor(private readonly http: HttpClient) {}

    get(id: string): Observable<OrderBillingInformationResponse> {
        return this.http.get<OrderBillingInformationResponse>(
            this.orderBillingInformationApiRoute.getByIdUrl(id),
        );
    }

    save(
        id: string,
        request: SaveOrderBillingInformationRequest,
    ): Observable<void> {
        return this.http.post<void>(
            this.orderBillingInformationApiRoute.getByIdUrl(id),
            request,
        );
    }
}
